import { render, staticRenderFns } from "./ColorFilters.vue?vue&type=template&id=74c4ebde&"
import script from "./ColorFilters.vue?vue&type=script&lang=js&"
export * from "./ColorFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports